import React from 'react';
import { Colors } from '../../constants/colors';

type Props = { color?: string; size?: number; strokeWidth?: number };

export const ArrowDownIcon = ({ color = Colors.primary, size = 50, strokeWidth = 3 }: Props) => (
  <svg width={size} height={size} viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7551 18.6907L25.1276 30.9407L37.5 18.6907"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
